import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LoginStore } from '@domains/login/store/login.store';
import { I18NextPipe } from 'angular-i18next';

export const brandTitle: ResolveFn<string> = () => inject(LoginStore).loginTitle() || inject(I18NextPipe).transform('mbs-ui:appTitle');
